// extracted by mini-css-extract-plugin
export default {"template2":"styles_template2__KFGlD"};